/**
 * SafeClick - Delegated, de-bubbled click binding
 *
 * Prevents accidental double handlers and backdrop/propagation side-effects
 * by stopping immediate propagation and deferring execution to rAF.
 */

export function bindSafeClick(root, selector, handler) {
  if (!root || !selector || typeof handler !== 'function') return () => {};

  const onClick = (e) => {
    const target = e.target?.closest?.(selector);
    if (!target || !root.contains(target)) return;
    e.preventDefault();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    e.stopPropagation();
    try {
      requestAnimationFrame(() => handler(e, target));
    } catch (err) {
      // Last-resort fallback
      setTimeout(() => handler(e, target), 0);
    }
  };

  root.addEventListener('click', onClick);
  return () => root.removeEventListener('click', onClick);
}

export default { bindSafeClick };

